import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { range } from 'lodash';
let CheckList = class CheckList extends Vue {
    constructor() {
        super(...arguments);
        this.range = range;
    }
    increment(index, isChecked) {
        this.$emit('changeSelected', isChecked ? index + 1 : index);
    }
};
__decorate([
    Prop(String)
], CheckList.prototype, "title", void 0);
__decorate([
    Prop(Number)
], CheckList.prototype, "current", void 0);
__decorate([
    Prop(Number)
], CheckList.prototype, "blocked", void 0);
__decorate([
    Prop(Number)
], CheckList.prototype, "maximum", void 0);
CheckList = __decorate([
    Component
], CheckList);
export default CheckList;
